 const HREF_ORIGIN = window.location.origin;

 let code;
 let url;

 // console.log(HREF_ORIGIN);
 //  console.log(process.env.NODE_ENV);
 if (process.env.NODE_ENV === "production") {
   code = "UA-16453534-3";
   if (HREF_ORIGIN === "http://www.openseas.gr") {
     url = "http://www.openseas.gr"
   } else {
     url = "http://www.openseas.gr"
   }
 } else {
   code = "UA-110809513-1";
   url = "http://www.openseas.gr"  //url = "http://localhost" 
 }

 export const ANALYTICS_CODE = code;
 export const FETCH_URL = url;


 export const mapping = {
   "AEG": "AEGINA",
   "SVA": "AEGINA-SOUVALA",
   "AGC": "AG.CONSTANTINOS",
   "AES": "AG.EYSTRATIOS",
   "AAM": "AG.MARINA-AEGINA",
   "AGA": "AGATHONISI",
   "AKA": "AGIOKAMPOS",
   "AGS": "AGISTRI",
   "AGG": "AGISTRI-MYLI",
   "SAR": "ALBANIA-AG. SARANTA",
   "DRZ": "ALBANIA-DURRES",
   "VOA": "ALBANIA-VLORA",
   "AXL": "ALEX/POLI",
   "ALL": "ALL",
   "ALO": "ALONISSOS",
   "AIG": "AMORGOS-AEGIALI",
   "AMO": "AMORGOS-KATAPOLA",
   "ANA": "ANAFI",
   "AND": "ANDROS",
   "AKT": "ANTIKYTHIRA",
   "ARK": "ARKYI",
   "JTY": "ASTYPALEA",
   "BRC": "BARCELONA",
   "BXN": "BODRUM",
   "CHL": "CHALKI",
   "ROU": "CHANIA-AG.ROUMELI",
   "GVD": "CHANIA-GAVDOS",
   "KIS": "CHANIA-KISSAMOS",
   "PSF": "CHANIA-PALEOHORA",
   "CSF": "CHANIA-SFAKIA",
   "SOG": "CHANIA-SOUGIA",
   "CHI": "CHIOS",
   "MHI": "CHIOS-MESTA",
   "CFU": "CORFU",
   "CHA": "CRETE-CHANIA",
   "HER": "CRETE-HERAKLIO",
   "JSH": "CRETE-SITIA",
   "DON": "DONOUSSA",
   "AED": "EVIA-AEDIPSOS",
   "AMN": "EVIA-AG.MARINA",
   "MTI": "EVIA-MANTOUDI",
   "MRM": "EVIA-MARMARI",
   "NST": "EVIA-NEA STIRA",
   "FOL": "FOLEGANDROS",
   "CHR": "FOURNOI-CHRISOMHLEA",
   "THY": "FOURNOI-THIMAINA",
   "GOS": "GINOSTRA",
   "GLY": "GLYFA",
   "GYT": "GYTHIO",
   "ERM": "HERMIONI",
   "HYD": "HYDRA",
   "IGO": "IGOUMENITSA",
   "AGK": "IKARIA-AG.KIRIKOS",
   "EYD": "IKARIA-EVDILOS",
   "FOU": "IKARIA-FOURNI",
   "INO": "INOUSSES",
   "IOS": "IOS",
   "IRK": "IRAKLIA",
   "ANC": "ITALY-ANCONA",
   "BAR": "ITALY-BARI",
   "BRI": "ITALY-BRINDISI",
   "CIV": "ITALY-CIVITAVECCHIA",
   "OLB": "ITALY-OLBIA",
   "TRE": "ITALY-TRIESTE",
   "KAL": "KALYMNOS",
   "AOK": "KARPATHOS",
   "DFN": "KARPATHOS-DIAFANI",
   "KSJ": "KASOS",
   "KAZ": "KASTELLORIZO",
   "KAV": "KAVALA",
   "KEA": "KEA",
   "PKE": "KEFALLONIA-POROS",
   "SMI": "KEFALLONIA-SAMI",
   "KIL": "KILINI",
   "KMS": "KIMOLOS",
   "KGS": "KOS",
   "MAS": "KOS-MASTIHARI",
   "KOU": "KOUFONISSI",
   "KTH": "KYTHIRA",
   "KYT": "KYTHNOS",
   "LMP": "LAMPEDUSA",
   "LAV": "LAVRIO",
   "LER": "LEROS",
   "LMN": "LIMNOS",
   "LIU": "LINOSA",
   "LAP": "LIPARI",
   "LIP": "LIPSI",
   "LIV": "LIVORNO",
   "LTR": "LOUTRO CHANION",
   "MET": "METHANA",
   "MLZ": "MILAZZO",
   "MLO": "MILOS",
   "JMK": "MYKONOS",
   "LES": "MYTILINI-LESVOS",
   "JNX": "NAXOS",
   "NEA": "NEAPOLIS",
   "NIS": "NISYROS",
   "PLE": "PALERMO",
   "PNA": "PANAREA",
   "PAS": "PAROS",
   "PMS": "PATMOS",
   "GRA": "PATRA",
   "PAX": "PAXI",
   "AKR": "PHTHIOTIS-ARKITSA",
   "PIR": "PIRAEUS",
   "POR": "POROS",
   "PEM": "PORTO EMPEDOCLE",
   "PHE": "PORTO HELI",
   "PTO": "PORTO TORRES",
   "PHA": "PSARA",
   "PSE": "PSERIMOS",
   "RAF": "RAFINA",
   "RNO": "RETHIMNO",
   "RHO": "RHODES",
   "RIN": "RINELLA",
   "SAL": "SALERNO",
   "SLA": "SALINA",
   "KAR": "SAMOS-KARLOVASSI",
   "PYT": "SAMOS-PYTHAGORIO",
   "BTH": "SAMOS-VATHI",
   "SAM": "SAMOTHRAKI",
   "JTR": "SANTORINI-THIRA",
   "SVN": "SAVONA",
   "SXI": "SCHINOUSSA",
   "SER": "SERIFOS",
   "SIF": "SIFNOS",
   "SIK": "SIKINOS",
   "JSI": "SKIATHOS",
   "SKO": "SKOPELOS",
   "GLO": "SKOPELOS-GLOSSA",
   "SPE": "SPETSES",
   "STR": "STROMBOLI",
   "SYM": "SYMI",
   "PAN": "SYMI-PANORMITIS",
   "JSY": "SYROS",
   "TNG": "TANGER",
   "SKG": "THESSALONIKI",
   "TRS": "THIRASSIA",
   "THL": "TILOS",
   "TIN": "TINOS",
   "TUN": "TUNIS",
   "AYV": "TURKEY-AYVALIK",
   "CES": "TURKEY-CESME",
   "FET": "TURKEY-FETHIYE",
   "KUS": "TURKEY-KUSADASI",
   "MAR": "TURKEY-MARMARIS",
   "TRR": "TURKEY-TURGUT REIS",
   "VEN": "VENICE",
   "VOL": "VOLOS",
   "VUL": "VULCANO",
   "ZTH": "ZAKYNTHOS",
 };


// WEBPACK FOOTER //
// ./src/utilities.js